import { http } from "./httpServices";
import {
  DOWNLOAD_DISPUTE_REFUND,
  REFUND_ADMIN_REQUEST,
  REFUND_DISPUTE_LIST,
  REFUND_DISPUTE_PROCESS,
} from "./constants";

export function getPendingRefundList() {
  return http.get(`${REFUND_DISPUTE_LIST}/?page=1&limit=100&status=processing`);
}

export function getAllRefundList() {
  return http.get(`${REFUND_DISPUTE_LIST}/?page=1&limit=100`);
}

export function processRefund(data: any) {
  return http.post(`${REFUND_DISPUTE_PROCESS}`, data);
}

export function addAdminRefundRequest(data: any) {
  return http.post(`${REFUND_ADMIN_REQUEST}`, data);
}

export function downloadDisputeReport(startDate: string, endDate: string) {
  return http.get(
    `${DOWNLOAD_DISPUTE_REFUND}?startDate=${startDate}&endDate=${endDate}`,
    { responseType: "blob" }
  );
}
